import baguetteBox from 'baguettebox.js';

export default (el) => {
    baguetteBox.run('.lightbox');
}
